// eslint-disable-next-line max-lines
import get from 'lodash/get'

import {
  sendErrorNotification,
  sendNotification,
  helpers,
} from 'react-mt-bootstrap'
import { formatMessage } from 'locale'

import { fetch } from 'containers/ClanManagement/proxy/helpers'
import { ITEMS_PER_PAGE } from 'state/reducers/recommended_clans'
import { prepareClanData } from './helpers/recommended_clans'
import {
  GATEWAY_ERROR_CODES_FOR_NOTIFICATIONS,
  NOTIFICATION_MESSAGES,
  LANDING_CLANS_ERROR_COOLDOWN,
} from 'containers/Landing/components/LandingClans/constants'
import { LIMIT } from '../reducers/recommended_clans'
import {
  DEFAULT_LIST_TYPE,
  DEFAULT_LANGUAGES,
} from '../../containers/Landing/components/LandingClans/components/Filters/constants'

export const RECOMMENDED_CLANS_REQUEST = 'recommended_clans/REQUEST'
export const RECOMMENDED_CLANS_SUCCESS = 'recommended_clans/SUCCESS'
export const RECOMMENDED_CLANS_APPEND_SUCCESS =
  'recommended_clans/APPEND_SUCCESS'
export const RECOMMENDED_CLANS_ERROR = 'recommended_clans/ERROR'
export const RECOMMENDED_CLANS_NEXT_PAGE = 'recommended_clans/NEXT_PAGE'
export const RECOMMENDED_CLANS_PREV_PAGE = 'recommended_clans/PREV_PAGE'
export const RECOMMENDED_CLANS_NEXT_PAGE_SEARCH =
  'recommended_clans/NEXT_PAGE_SEARCH'
export const RECOMMENDED_CLANS_PREV_PAGE_SEARCH =
  'recommended_clans/PREV_PAGE_SEARCH'
export const RECOMMENDED_CLANS_SET_LANGUAGE_CODE =
  'recommended_clans/SET_LANGUAGE_CODE'
export const RECOMMENDED_CLANS_SET_MEMBERS_COUNT =
  'recommended_clans/SET_MEMBERS_COUNT'
export const RECOMMENDED_CLANS_SET_LIST_TYPE =
  'recommended_clans/SET_LIST_TYPE'
export const RECOMMENDED_CLANS_SET_SEARCH_TERM =
  'recommended_clans/SET_SEARCH_TERM'

export const RECOMMENDED_CLANS_ACCOUNT_STATUS_CLEAR =
  'recommended_clans/ACCOUNT_STATUS_CLEAR'
export const RECOMMENDED_CLANS_ACCOUNT_STATUS_REQUEST =
  'recommended_clans/ACCOUNT_STATUS_REQUEST'
export const RECOMMENDED_CLANS_ACCOUNT_STATUS_FETCHING_COMPLETED =
  'recommended_clans/ACCOUNT_STATUS_FETCHING_COMPLETED'
export const RECOMMENDED_CLANS_ACCOUNT_STATUS_ERROR =
  'recommended_clans/ACCOUNT_STATUS_ERROR'

export const RECOMMENDED_CLANS_ACCEPT_INVITE_REQUEST =
  'recommended_clans/ACCEPT_INVITE_REQUEST'
export const RECOMMENDED_CLANS_ACCEPT_INVITE_SUCCESS =
  'recommended_clans/ACCEPT_INVITE_SUCCESS'
export const RECOMMENDED_CLANS_ACCEPT_INVITE_ERROR =
  'recommended_clans/ACCEPT_INVITE_ERROR'

export const RECOMMENDED_CLANS_AUTO_JOIN_REQUEST =
  'recommended_clans/AUTO_JOIN_REQUEST'
export const RECOMMENDED_CLANS_AUTO_JOIN_SUCCESS =
  'recommended_clans/AUTO_JOIN_SUCCESS'
export const RECOMMENDED_CLANS_AUTO_JOIN_ERROR =
  'recommended_clans/AUTO_JOIN_ERROR'

export const RECOMMENDED_CLANS_SEND_APPLICATION_REQUEST =
  'recommended_clans/SEND_APPLICATION_REQUEST'
export const RECOMMENDED_CLANS_SEND_APPLICATION_SUCCESS =
  'recommended_clans/SEND_APPLICATION_SUCCESS'
export const RECOMMENDED_CLANS_SEND_APPLICATION_ERROR =
  'recommended_clans/SEND_APPLICATION_ERROR'

export const RECOMMENDED_CLANS_FILTER_SETTINGS_REQUEST =
  'recommended_clans/FILTER_SETTINGS_REQUEST'
export const RECOMMENDED_CLANS_FILTER_SETTINGS_SUCCESS =
  'recommended_clans/FILTER_SETTINGS_SUCCESS'
export const RECOMMENDED_CLANS_FILTER_SETTINGS_ERROR =
  'recommended_clans/FILTER_SETTINGS_ERROR'
export const RECOMMENDED_CLANS_CALL_ENTER_CLAN =
  'recommended_clans/CALL_ENTER_CLAN'

export const RECOMMENDED_CLANS_SYSTEM_ERROR = 'recommended_clans/SYSTEM_ERROR'
export const RECOMMENDED_CLANS_STOP_LOADING = 'recommended_clans/STOP_LOADING'

const ACCOUNT_STATUS_FETCH_INTERVAL = 1000
const ACCOUNT_STATUS_MAX_ATTEMPTS = 7
const DISPLAY_LOADING_INTERVAL = 3000

export const startFetchClansRequest = () => ({
    type: RECOMMENDED_CLANS_REQUEST,
})

export const startAcceptInviteRequest = () => ({
    type: RECOMMENDED_CLANS_ACCEPT_INVITE_REQUEST,
})

export const startAutoJoinRequest = () => ({
    type: RECOMMENDED_CLANS_AUTO_JOIN_REQUEST,
})

export const startSendApplicationRequest = () => ({
    type: RECOMMENDED_CLANS_SEND_APPLICATION_REQUEST,
})

export const startAccountStatusRequest = () => ({
    type: RECOMMENDED_CLANS_ACCOUNT_STATUS_REQUEST,
})

export const selectNextPage = () => {
    return (dispatch, getState) => {
        const {
      items,
      total,
      paging,
      pagingSearch,
      searchTerm,
    } = getState().recommendedClans
        const isSearch = searchTerm !== null
        if (isSearch) {
            dispatch({ type: RECOMMENDED_CLANS_NEXT_PAGE_SEARCH })
        } else {
            dispatch({ type: RECOMMENDED_CLANS_NEXT_PAGE })
        }
        const expectedItems =
      (isSearch ? pagingSearch.current + 2 : paging.current + 2) *
      ITEMS_PER_PAGE

        if (total > items.length && expectedItems > items.length) {
            dispatch(fetchRecommendedClans(true))
        }
    }
}

export const selectPrevPage = () => {
    return (dispatch, getState) => {
        if (getState().recommendedClans.searchTerm !== null) {
            dispatch({ type: RECOMMENDED_CLANS_PREV_PAGE_SEARCH })
        } else {
            dispatch({ type: RECOMMENDED_CLANS_PREV_PAGE })
        }
    }
}

export const setLanguageCode = languages => ({
    type: RECOMMENDED_CLANS_SET_LANGUAGE_CODE,
    payload: {
        languages,
    },
})

export const setMembersCount = membersCount => ({
    type: RECOMMENDED_CLANS_SET_MEMBERS_COUNT,
    payload: {
        membersCount,
    },
})

export const setListType = listType => ({
    type: RECOMMENDED_CLANS_SET_LIST_TYPE,
    payload: {
        listType,
    },
})

export const setSearchTerm = searchTerm => ({
    type: RECOMMENDED_CLANS_SET_SEARCH_TERM,
    payload: {
        searchTerm,
    },
})

export const startFilterSettingsRequest = () => ({
    type: RECOMMENDED_CLANS_FILTER_SETTINGS_REQUEST,
})

export const formatCooldownError = (cooldown, isLanding) => {
    if (cooldown) {
        const date = new Date(`${cooldown}Z`).toISOString()
        if (isLanding) {
            return formatMessage(LANDING_CLANS_ERROR_COOLDOWN.accountInCooldown, {
                date: helpers.isoToFormattedLocalDate(date),
                time: helpers.isoToFormattedLocalTime(date),
            })
        }
        return formatMessage(NOTIFICATION_MESSAGES.accountInCooldown, {
            date: helpers.isoToFormattedLocalDate(date),
            time: helpers.isoToFormattedLocalTime(date),
        })
    }
    return null
}

export const formatError = errorCode => {
    if (!GATEWAY_ERROR_CODES_FOR_NOTIFICATIONS[errorCode]) return
    return formatMessage(
    NOTIFICATION_MESSAGES[GATEWAY_ERROR_CODES_FOR_NOTIFICATIONS[errorCode]]
  )
}

export const formatCommonError = () => {
    return formatMessage(NOTIFICATION_MESSAGES.commonError)
}

export const requestSuccess = (data, isSearch) => {
    return {
        type: RECOMMENDED_CLANS_SUCCESS,
        payload: {
            cooldownTill: get(data, 'account_data.in_clan_cooldown_till', null),
            items: prepareClanData(data.items),
            total: data.total,
            dwhType: data.dwh_type,
            isSearch,
        },
    }
}

export const requestAppendSuccess = (data, isSearch) => {
    return {
        type: RECOMMENDED_CLANS_APPEND_SUCCESS,
        payload: {
            cooldownTill: get(data, 'account_data.in_clan_cooldown_till', null),
            items: prepareClanData(data.items),
            total: data.total,
            dwhType: data.dwh_type,
            isSearch,
        },
    }
}

export const requestError = errorMessage => {
  // eslint-disable-next-line no-console
    console.error(errorMessage)
    return {
        type: RECOMMENDED_CLANS_ERROR,
    }
}

export const requestFilterSettingsSuccess = settings => ({
    type: RECOMMENDED_CLANS_FILTER_SETTINGS_SUCCESS,
    payload: {
        ...settings,
        game_activity: settings.game_activity || DEFAULT_LIST_TYPE,
        languages:
      settings.languages === null ? DEFAULT_LANGUAGES : settings.languages,
    },
})

export const clearAccountStatus = () => ({
    type: RECOMMENDED_CLANS_ACCOUNT_STATUS_CLEAR,
})

export const completeAccountFetching = (
  isAccountInClan,
  isAccountConflicted
) => ({
    type: RECOMMENDED_CLANS_ACCOUNT_STATUS_FETCHING_COMPLETED,
    payload: {
        isAccountInClan,
        isAccountConflicted,
    },
})

export const requestAccountStatusError = () => ({
    type: RECOMMENDED_CLANS_ACCOUNT_STATUS_ERROR,
})

export const requestFilterSettingsError = () => ({
    type: RECOMMENDED_CLANS_FILTER_SETTINGS_ERROR,
})

const prepareQuery = state => {
    const query = {
        limit: LIMIT,
        offset: state.recommendedClans.paging.offset,
    }
    if (state.recommendedClans.searchTerm) {
        query['term'] = state.recommendedClans.searchTerm
        query.offset = state.recommendedClans.pagingSearch.offset
        return query
    }

    if (state.recommendedClans.membersCount) {
        query['min_members_count'] = state.recommendedClans.membersCount
    }
    if (
    state.recommendedClans.languages &&
    state.recommendedClans.languages.length
  ) {
        query['languages'] = Array.from(state.recommendedClans.languages).join(',')
    }
    if (state.recommendedClans.listType) {
        query['list_type'] = state.recommendedClans.listType
    }
    return query
}

export const fetchRecommendedClans = isAppend => {
    return async (dispatch, getState) => {
        const state = getState()
        const query = prepareQuery(state)
        const isSearch = state.recommendedClans.searchTerm !== null

        dispatch(startFetchClansRequest())
        try {
            const successData = await fetch(
        `${state.settings.gatewayHost}/cwh/wot/clans/recommended/`,
        { query }
      )
            isAppend ?
        dispatch(requestAppendSuccess(successData, isSearch)) :
        dispatch(requestSuccess(successData, isSearch))
        } catch (errorData) {
            dispatch(requestError(errorData))
        }
    }
}

export const enterClan = clan => {
    return dispatch => {
        const { inviteId, isClanAcceptableForAutoJoining } = clan
        dispatch({ type: RECOMMENDED_CLANS_CALL_ENTER_CLAN })

        if (inviteId !== null) {
            dispatch(acceptInvite(clan))
        } else if (isClanAcceptableForAutoJoining) {
            dispatch(autoJoin(clan))
        } else {
            dispatch(sendApplication(clan))
        }
    }
}

export const acceptInvite = clan => {
    return async (dispatch, getState) => {
        const { inviteId, id: clanId } = clan
        const state = getState()
        const query = { source: 'non_clan_landing', status: 'accepted' }
        const method = 'PATCH'

        dispatch(startAcceptInviteRequest(clanId))
        try {
            await fetch(`${state.settings.gatewayHost}/clans/invites/${inviteId}/`, {
                query,
                method,
            })
            dispatch(acceptInviteSuccess(clan))
            dispatch(fetchAccountStatus())
        } catch (errorData) {
            dispatch(acceptInviteError(clan, errorData))
        }
    }
}

export const acceptInviteSuccess = clan => ({
    type: RECOMMENDED_CLANS_ACCEPT_INVITE_SUCCESS,
    payload: {
        clan,
    },
})

export const acceptInviteError = (clan, errorData) => {
    return (dispatch, getState) => {
        const errorCode = get(errorData, 'code', 1)
        const actualPolicy = get(
      errorData,
      'additional_data.actual_policy',
      'opened'
    )
        const { id: clanId, isClanAcceptableForAutoJoining } = clan
        const { attemptsEnterClan, joinResult } = getState().recommendedClans

        let errorMessage = ''
        let currentClan = null

        switch (true) {
        case errorCode === 19:
            currentClan = clan
            break
        case attemptsEnterClan.autoJoin === false &&
        errorCode === 25 &&
        isClanAcceptableForAutoJoining:
            dispatch(autoJoin(clan))
            break
        case attemptsEnterClan.sendApplication === false &&
        errorCode === 25 &&
        !isClanAcceptableForAutoJoining:
            dispatch(sendApplication(clan))
            break
        case errorCode === 43:
            errorMessage = formatCooldownError(joinResult.cooldownTill)
            break
        case errorCode === 18:
        case errorCode === 21 && actualPolicy === 'closed':
            errorMessage = formatError(errorCode)
            break
        default:
            dispatch(displayJoinLoading(clanId, errorCode))
            break
        }

        if (errorMessage === '' && currentClan === null) {
            return
        }

        sendErrorNotification(errorMessage)

        dispatch({
            type: RECOMMENDED_CLANS_ACCEPT_INVITE_ERROR,
            payload: {
                clanId,
                errorCode,
                currentClan,
            },
        })
    }
}

export const autoJoin = clan => {
    return async (dispatch, getState) => {
        const clanId = clan.id
        const state = getState()
        const query = { self: true, autofill_accounts_statistics: true }
        const method = 'POST'

        dispatch(startAutoJoinRequest(clanId))
        try {
            await fetch(`${state.settings.gatewayHost}/clans/${clanId}/members/`, {
                query,
                method,
            })
            dispatch(autoJoinSuccess(clan))
            dispatch(fetchAccountStatus())
        } catch (errorData) {
            dispatch(autoJoinError(clan, errorData))
        }
    }
}

export const autoJoinSuccess = clan => ({
    type: RECOMMENDED_CLANS_AUTO_JOIN_SUCCESS,
    payload: { clan },
})

export const autoJoinError = (clan, errorData) => {
    return (dispatch, getState) => {
        const errorCode = get(errorData, 'code', 1)
        const actualPolicy = get(
      errorData,
      'additional_data.actual_policy',
      'opened'
    )
        const { id: clanId } = clan
        const { attemptsEnterClan } = getState().recommendedClans

        let errorMessage = ''
        let currentClan = null

        switch (true) {
        case errorCode === 19:
            currentClan = clan
            break
        case attemptsEnterClan.acceptInvite === false && errorCode === 41:
            dispatch(acceptInvite(clan))
            break
        case attemptsEnterClan.sendApplication === false &&
        errorCode === 21 &&
        actualPolicy === 'restricted':
        case errorCode === 43:
        case errorCode === 18:
        case errorCode === 22:
            dispatch(sendApplication(clan))
            break
        case errorCode === 21 && actualPolicy === 'closed':
            errorMessage = formatError(errorCode)
            break
        default:
            dispatch(displayJoinLoading(clanId, errorCode))
            break
        }

        if (errorMessage === '' && currentClan === null) {
            return
        }

        sendErrorNotification(errorMessage)
        dispatch({
            type: RECOMMENDED_CLANS_AUTO_JOIN_ERROR,
            payload: {
                clanId,
                errorCode,
                currentClan,
            },
        })
    }
}

export const sendApplication = clan => {
    return async (dispatch, getState) => {
        const clanId = clan.id
        const state = getState()
        const query = { clan_ids: clanId, source: 'non_clan_landing', comment: '' }
        const method = 'POST'

        dispatch(startSendApplicationRequest(clanId))
        try {
            await fetch(`${state.settings.gatewayHost}/clans/applications/`, {
                query,
                method,
            })
            dispatch(sendApplicationSuccess(clan))
        } catch (errorData) {
            dispatch(sendApplicationError(clan, errorData))
        }
    }
}

export const sendApplicationSuccess = clan => {
    sendNotification(
    'Warning',
    formatMessage(NOTIFICATION_MESSAGES.applicationSent)
  )
    return {
        type: RECOMMENDED_CLANS_SEND_APPLICATION_SUCCESS,
        payload: {
            clan,
        },
    }
}

export const sendApplicationError = (clan, errorData) => {
    return (dispatch, getState) => {
        const errorCode = get(errorData, 'code', 1)
        const actualPolicy = get(
      errorData,
      'additional_data.actual_policy',
      'restricted'
    )
        const clanId = clan.id
        const { attemptsEnterClan } = getState().recommendedClans

        let errorMessage = ''
        let currentClan = null

        switch (true) {
        case errorCode === 19:
            currentClan = clan
            break
        case attemptsEnterClan.acceptInvite === false && errorCode === 41:
            dispatch(sendApplication(clan))
            break
        case errorCode === 21 && actualPolicy === 'closed':
            errorMessage = formatError(errorCode)
            break
        case errorCode === 42:
            dispatch(sendApplicationSuccess(clan))
            break
        default:
            dispatch(displayJoinLoading(clanId, errorCode))
            break
        }

        if (errorMessage === '' && currentClan === null) {
            return
        }

        sendErrorNotification(errorMessage)
        dispatch({
            type: RECOMMENDED_CLANS_SEND_APPLICATION_ERROR,
            payload: {
                clanId,
                errorCode,
                currentClan,
            },
        })
    }
}

export const displayJoinLoading = (clanId, errorCode) => {
    return dispatch => {
        dispatch({
            type: RECOMMENDED_CLANS_SYSTEM_ERROR,
            payload: { clanId, errorCode },
        })
        sendErrorNotification(formatCommonError())

        setTimeout(() => {
            dispatch({ type: RECOMMENDED_CLANS_STOP_LOADING })
        }, DISPLAY_LOADING_INTERVAL)
    }
}

export const fetchAccountStatus = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const accountId = state.account.id
        const query = {
            account_ids: [accountId],
            fields: ['clan_id', 'status'].join(','),
        }

        dispatch(startAccountStatusRequest())
        try {
            const data = await fetch(
        `${state.settings.gatewayHost}/accounts/clans/`,
        { query }
      )
            const isAccountInClan = !!(data[0] && data[0]['clan_id'])
            const isAccountConflicted = !!(
        data[0] && data[0]['status'] === 'conflict'
      )
            const isMaxAttemptsReached =
        state.recommendedClans.accountStatus.attempt + 1 >=
        ACCOUNT_STATUS_MAX_ATTEMPTS

            if (isAccountInClan || isAccountConflicted || isMaxAttemptsReached) {
                dispatch(completeAccountFetching(isAccountInClan, isAccountConflicted))
            } else {
                setTimeout(() => {
                    dispatch(fetchAccountStatus())
                }, ACCOUNT_STATUS_FETCH_INTERVAL)
            }
        } catch (errorData) {
            dispatch(requestAccountStatusError())
        }
    }
}

export const fetchFilterSettings = () => {
    return async (dispatch, getState) => {
        const state = getState()

        dispatch(startFilterSettingsRequest())
        try {
            const successData = await fetch(
        `${state.settings.gatewayHost}/cwh/wot/clans/recommended/settings`
      )
            dispatch(requestFilterSettingsSuccess(successData))
        } catch (errorData) {
            dispatch(requestFilterSettingsError(errorData))
        }
    }
}

export const sendFilterSettings = () => {
    return async (dispatch, getState) => {
        const { recommendedClans, settings } = getState()
        const body = {
            languages: recommendedClans.languages,
            game_activity: recommendedClans.listType,
        }
        const method = 'POST'

        dispatch(startFilterSettingsRequest())
        try {
            await fetch(
        `${settings.gatewayHost}/cwh/wot/clans/recommended/settings/`,
                {
                    body,
                    method,
                }
      )
        } catch (errorData) {
            dispatch(requestFilterSettingsError(errorData))
        }
    }
}

export const fetchRecommendedClansWithSettings = () => {
    return async dispatch => {
        await dispatch(fetchFilterSettings())
        await dispatch(fetchRecommendedClans())
    }
}



// WEBPACK FOOTER //
// ./state/actions/recommended_clans.js